<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 2xl:flex 2xl:flex-row items-start gap-5 sm:gap-[45px]">
    <ReviewsCommentItem
      v-for="(comment, index) in comments"
      :key="index"
      v-bind="{ ...comment }"
      :class="[rotations[index], index === 2 && 'lg:col-span-2 justify-self-center']"
    />
  </div>
</template>

<script setup lang="ts">
import ReviewsCommentItem from './reviews-comment-item.vue'
import commentsData from '@/assets/comments.json'
import commentsSamsData from '@/assets/comments-sams.json'
import commentsLocatorData from '@/assets/comments-locator.json'
import { getRandomRotations } from '@/utils/reviews-comments'
import { ref } from 'vue'

export interface Props {
  type?: 'default' | 'sams' | 'locator'
}

const props = defineProps<Props>()

const getCommentsByType = (type: Props['type']) => {
  switch (type) {
    case 'sams':
      return commentsSamsData
    case 'locator':
      return commentsLocatorData
    default:
      return [ ...commentsData ].sort(() => Math.random() - 0.5).slice(0, 3)
  }
}

/* Gets data depending on type */
const comments = ref(getCommentsByType(props.type))
const rotations = ref(getRandomRotations())
</script>